const SETUP_TYPES = {
  LANE: "By Lane",
  PLAYER: "By Player",
  LANE_V2: "By Lane V2",
};

export default SETUP_TYPES;
